import VpnLockIcon from "@mui/icons-material/VpnLock";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import MedicalInformationOutlinedIcon from "@mui/icons-material/MedicalInformationOutlined";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
const menuItems = [];
const userType = window.sessionStorage.getItem("user")
  ? JSON.parse(window.sessionStorage.getItem("user"))["role"]
  : "";

const SystemAdminMenuItems = {
  items: [
    {
      name: "Users",
      // icon: VpnLockIcon,
      link: "/users",
    },
    {
      name: "Spaces",
      // icon: VpnLockIcon,
      link: "/spaces",
    },
    {
      name: "Equipment",
      // icon: VpnLockIcon,
      link: "/equipment",
    },
    {
      name: "Services",
      // icon: VpnLockIcon,
      link: "/services",
    },
    {
      name: "Packages",
      // icon: VpnLockIcon,
      link: "/packages",
    },
    {
      name: "Scheduling",
      // icon: VpnLockIcon,
      link: "/scheduling",
    },
    {
      name: "Settings",
      // icon: VpnLockIcon,
      link: "/settings",
    },
    {
      name: "Clients",
      // icon: VpnLockIcon,
      link: "/clients",
    },
  ],
};

menuItems.push(SystemAdminMenuItems);

export default menuItems;
